import { useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useStore } from "@/context/StoreContext";

export default function PriceListDownload() {
  const [busy, setBusy] = useState(false);
  const { active } = useStore();
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/reports/price-list", { params: { store_id: active?.store_id, _ts: Date.now() }, responseType: "blob" });
      const served = res.headers["x-export-store-id"];
      if (active?.store_id && served && served !== active.store_id) throw new Error("store mismatch");
      const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "Price List.xlsx";
      const url = URL.createObjectURL(res.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`Downloaded ${name}`);
    } catch {
      toast.error("Could not generate the price list");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant="outline" data-testid="download-price-list-btn" disabled={busy} onClick={download} className="rounded-full">
      <FileSpreadsheet className="w-4 h-4 mr-2" strokeWidth={1.5} /> {busy ? "Preparing…" : "Download price list"}
    </Button>
  );
}
